export default {"src":"/_next/static/media/sync_player_ring.5c71b654.svg","height":129,"width":128,"blurWidth":0,"blurHeight":0};